import classNames from 'classnames';
import type { PropsWithChildren } from 'react';

type ChipProps = {
  className?: string;
  disabled?: boolean;
};

export const Chip = ({ children, className, disabled }: PropsWithChildren<ChipProps>) => (
  <span className={classNames('rounded-xl text-sm text-center px-2 py-1', className, {
    'text-primary bg-primary-light': !disabled,
    'text-medium bg-light': disabled,
  })}>
    {children}
  </span>
);

export default Chip;
